import { getRandomAndUniqueKey } from '../../utils/globalFunctions';

export const initialValuesAddUbication = {
  isOyM: null,
  ubication: {
    ubicationType: null,
    uunn: null,
    ubication: '',
    event: null,
    team: null,
    installation: null,
    equipment: null,
    classification: null
  },
  imputationObject: {
    wells: []
  }
};

export const initialValuesSDS = {
  isOyM: false,
  isTemplate: false,
  templateIsPublic: false,
  changeDependencieApprover: 0,
  currentStep: 1,
  templateName: '',
  ubication: {
    ubicationType: null,
    uunn: null,
    installation: null,
    typeEvent: null,
    ubication: '',
    event: null,
    team: null,
    classification: null,
    operationType: null
  },
  imputationObject: {
    wells: []
  },
  accordions: [
    {
      accordionId: getRandomAndUniqueKey(),
      accordionStep: 2,
      service: {
        service: null,
        probDate: '',
        needDate: '',
        description: '',
        priority: null
      },
      provider: {
        providers: []
      },
      associatedUsers: {
        approvers: [],
        inspectors: [],
        receivers: [],
        aditionalReceivers: []
      }
    }
  ]
};
export const initialServiceAccordion = {
  ...initialValuesSDS.accordions[0],
  accordionStep: 2,
  accordionId: getRandomAndUniqueKey(),
  service: {
    currentStepService: null,
    service: null,
    probDate: '',
    needDate: '',
    description: ''
  }
};

export const stepEnum = {
  ubication: 1,
  services: 2
};

export const stepEnumOfAccordion = {
  ubicacion: 1,
  service: 2,
  provider: 3,
  associatedUsers: 4,
  files: 5
};
